module.exports = __webpack_public_path__ + "static/media/condenser-01.138deac3.png";